import {validate} from 'email-validator'

const validateWebsiteAddress = (rule, value, callback) => {
  const reg = /((http|https):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi
  if ((rule.required && value.length <= 0)) {
    callback(new Error('Enter a valid website address'))
  } else if (value.length > 0 && reg.test(value)==false) {
    callback(new Error('Website address field must be valid'))
  } else {
    callback()
  }
}

const validateEmail = (rule, value, callback) => {
  if (rule.required && value.length <= 0) {
    callback(new Error('Enter a valid email address'))
  } else if (value.length > 0 && validate(value) == false) {
    callback(new Error('Enter a valid email address'))
  } else {
    callback()
  }
}

const validateContactNumber = (rule, value, callback) => {

  let reg = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i
  if (rule.required && value.length <= 0) {
    callback(new Error('Enter a valid contact number'))
  } else if (value.length > 0 && value.length < 7) {
    callback(new Error('Contact number may not be less than 7 characters'))
  } else if (value.length > 20) {
    callback(new Error('Contact number may not be greater than 20 characters'))
  } else if (value.length > 0 && reg.test(value)==false) {
    callback(new Error('Contact number field must be valid'))
  } else {
    callback()
  }
}

export { validateWebsiteAddress, validateEmail, validateContactNumber}